var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDlpStarBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64062 1.24219L10.4453 4.87891L14.4375 5.45312C15.1484 5.5625 15.4492 6.4375 14.9297 6.95703L12.0312 9.74609L12.7148 13.7109C12.8242 14.4219 12.0859 14.9688 11.4297 14.6406L7.875 12.7812L4.29297 14.668C3.63672 14.9961 2.89844 14.4492 3.00781 13.7383L3.69141 9.77344L0.792969 6.95703C0.273438 6.4375 0.574219 5.5625 1.28516 5.45312L5.27734 4.87891L7.08203 1.24219C7.41016 0.585938 8.33984 0.613281 8.64062 1.24219Z",
    fill: "#4D5BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlpStarBlue);
export default __webpack_public_path__ + "static/media/DlpStarBlue.b485611eb22914cd7940bd581dc5fa31.svg";
export { ForwardRef as ReactComponent };